import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ProcessingQueueSdk } from '../sdks/processing-queue.sdk';
import { IStepRequest } from '../models/ui/job-request/job-request.model';
import { ProcessingHubSdk } from '../sdks/processing.hub-sdk';
import { ProcessingStep } from '../models/ui/processing-step.model';

@Injectable({
	providedIn: 'root'
})
export class ProcessingManager {
	public activeSteps$ = this.processingHubSdk.activeSteps$;
	public allSteps$ = this.processingHubSdk.allSteps$;
	public outOfSync$ = this.processingHubSdk.indexDocCountOutOfSync$;
	public kbOutOfSync$ = this.processingHubSdk.kbDocCountOutOfSync$;
	public servers$ = this.processingHubSdk.servers$;
	public ms$ = this.processingHubSdk.microservicesSummary$;
	public workflows$ = this.processingHubSdk.workflows$;


	public currentActiveStep$: Observable<string>;
	public currentFilterText$: Observable<string>;
	public snapshot$: Observable<ProcessingStep[]>;
	public currentRowHeight$: Observable<number>;

	private currentActiveStepSource = new BehaviorSubject<string>(null);
	private currentFilterTextSource = new BehaviorSubject<string>(null);
	private snapshotSource = new BehaviorSubject<ProcessingStep[]>(null);
	private currentRowHeightSource = new BehaviorSubject<number>(38);

	constructor(
		private processingQueueSdk: ProcessingQueueSdk,
		private processingHubSdk: ProcessingHubSdk
	) {
		this.currentActiveStep$ = this.currentActiveStepSource.asObservable();
		this.currentFilterText$ = this.currentFilterTextSource.asObservable();
		this.snapshot$ = this.snapshotSource.asObservable();
		this.currentRowHeight$ = this.currentRowHeightSource.asObservable();
	}

	public scheduleStep(params?: ScheduleStepParams): Observable<void> {
		return this.processingQueueSdk.schedule(params);
	}

	public getProcessingStepDetails(id: string): Observable<ProcessingStep> {
		return this.processingQueueSdk.getStep({ id: id });
	}

	public setCurrentActiveStepId(stepId: string): void {
		this.currentActiveStepSource.next(stepId);
	}

	public setSearchText(searchText: string): void {
		this.currentFilterTextSource.next(searchText);
	}

	public retryStep(stepId: string): Observable<void> {
		return this.processingQueueSdk.action({
			action: {
				stepActionType: 'retry',
				stepId
			}
		});
	}

	public failStep(stepId: string): Observable<void> {
		return this.processingQueueSdk.action({
			action: {
				stepActionType: 'fail',
				stepId
			}
		});
	}

	public refreshSnapshot(): void {
		this.processingQueueSdk.getSnapshot().subscribe((snapshot) => {
			this.snapshotSource.next(snapshot);
		});
	}

	public setRowHeight(amount: number): void {
		this.currentRowHeightSource.next(amount);
	}

}

interface ScheduleStepParams {
	stepRequest: IStepRequest;
}
